module.exports = __webpack_public_path__ + "static/media/portfolio_3.07a6380d.jpeg";